import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const ButtonLinkSayman = () => {
    return (
        <div className="button-link-sayman-wrapper">
            <div className="sayman-application-button-header xpt-3 xpb-3">
                <div className="container-fluid" id="toggle-button-sayman">
                    <div className="d-none d-lg-block">
                        <a href="#">
                            هم اکنون در سایمان دیجیتال SE آیفون
                        </a>
                    </div>
                    <div className="d-block d-lg-none">
                        <a href="#" className="position-relative">
                            اپلیکیشن جدید سایمان را نصب کنید!
                            <span className="icon-close position-absolute" id="close-button-sayman">
                            <IconName name="expand_close" className="icon"/>
                        </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ButtonLinkSayman;
